import React, { Fragment, memo } from 'react';
import type { FC } from 'react';
// We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line no-restricted-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { N20A } from '@atlaskit/theme/colors';
import { FadeIn, StaggeredEntrance, prefersReducedMotion } from '@atlaskit/motion';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const SkeletonWrapper = styled.div`
	margin-bottom: ${token('space.200', '16px')};
	${prefersReducedMotion()};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const SkeletonBody = styled.div`
	background: ${token('color.skeleton', N20A)};
	height: 197px;
	width: 100%;
	border-radius: token('border.radius.100', '8px');
`;

type SkeletonProps = {
	useEntranceAnimation?: boolean;
};

export const FeedCardSkeleton: FC<SkeletonProps> = ({ useEntranceAnimation }) => {
	if (useEntranceAnimation) {
		return (
			<FadeIn entranceDirection="bottom">
				{(animationProps) => (
					<SkeletonWrapper {...animationProps} data-testid="feed-card-skeleton">
						<SkeletonBody />
					</SkeletonWrapper>
				)}
			</FadeIn>
		);
	}

	return (
		<SkeletonWrapper data-testid="feed-card-skeleton">
			<SkeletonBody />
		</SkeletonWrapper>
	);
};

export const LoadingSkeleton: FC<SkeletonProps> = memo(
	({ useEntranceAnimation }) => {
		const Wrapper = useEntranceAnimation ? StaggeredEntrance : Fragment;
		return (
			<Wrapper columns={1}>
				<FeedCardSkeleton useEntranceAnimation={useEntranceAnimation} />
				<FeedCardSkeleton useEntranceAnimation={useEntranceAnimation} />
			</Wrapper>
		);
	},
	() => true,
);
